import track, { useTracking } from 'react-tracking';
import { ROUTE_PLANS } from '@/constants/routes';
import { Modal } from '@simplywallst/ui-core';
import { RouterLink } from '@redux-first-router-link';
import ViewedCompanies from '@user/components/ViewedCompanies/ViewedCompanies';
import { ViewedCompaniesWrapper, ViewedCompaniesModalWrapper } from './styled';

import { useCompanyLimits } from '@/hooks/useCompanyLimits';

interface Props {
  onClose: () => void;
}

const ViewedCompaniesModal = ({ onClose }: Props) => {
  const { trackEvent } = useTracking();
  const limits = useCompanyLimits();
  return (
    <Modal
      title="Plan Limits"
      primaryLabel="OK, got it"
      onPrimaryClick={onClose}
      onSecondaryClick={onClose}
      removeWindowScroll={false}
    >
      <ViewedCompaniesModalWrapper>
        <p>
          {`You've used ${limits.views}/${limits.limit} spots of your current
          Plan's company view limit:`}
        </p>
        <ViewedCompaniesWrapper>
          <ViewedCompanies
            list={limits.companies}
            light={true}
            handleClick={onClose}
          />
        </ViewedCompaniesWrapper>
        {RUNTIME_ENV !== 'native' && (
          <p>
            <span>Want to get unlimited company views? </span>
            <RouterLink
              to={{ type: ROUTE_PLANS }}
              onClick={() => {
                onClose();
                trackEvent({
                  action: 'click',
                  modifier: 'upgrade',
                });
              }}
            >
              Upgrade plans.
            </RouterLink>
          </p>
        )}
      </ViewedCompaniesModalWrapper>
    </Modal>
  );
};

export default track({
  type: 'track',
  subject: 'ViewedCompaniesModal',
})(ViewedCompaniesModal) as typeof ViewedCompaniesModal;
